/**
 * Created by nemio on 27.11.2015.
 */
import en_US from '../../en_US';

const extend = {
  tv: 'TV',
  watch_now: 'Watch Now',
  on_demand: 'On Demand',
  on_now: 'TV Guide',
  featured: 'Featured',
  page: {
    ...en_US.page,
    epg: 'TV Guide'
  }
};

const en_AS = {...en_US, ...extend};

export default en_AS;



// WEBPACK FOOTER //
// ./src/locales/dics/ext/appstar/en_AS.js